import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import { useContext, useState } from 'react'
import AppContext from '../../context/appContext'
import { useSOCSamples, useRemoveSOCSample } from '../../hooks/data/useSOCSamples'
import { useUserRole } from '../../hooks/useUserRole'
import { SOCSampleWithDocuments } from '../../types/apiModels'
import { useDownloadSOCSample } from './export/useDownloadSOCSample'
import SOCSampleDialog, { type SOCSampleDialogMode } from './SOCSampleDialog/SOCSampleDialog'
import SOCSamplesList from './SOCSamplesList'

const SOCSample = () => {
  const { currentFarm, setConfirmationModalConfig } = useContext(AppContext)
  const [selectedSOCSample, setSelectedSOCSample] = useState<SOCSampleWithDocuments | null>(null)
  const [createSOCSampleView, setCreateSOCSampleView] = useState(false)
  const [dialogMode, setDialogMode] = useState<SOCSampleDialogMode>('edit')
  const { isViewOnly } = useUserRole()

  const { data: socSamples } = useSOCSamples(currentFarm?.id)
  const { mutateAsync: removeSOCSample } = useRemoveSOCSample(currentFarm?.id)
  const { mutate: downloadSOCSample, isPending: isDownloading } = useDownloadSOCSample(currentFarm)

  const handleDeleteSOCSample = (monitorSOCSampleId: string) => {
    setConfirmationModalConfig({
      open: true,
      title: 'Confirmar eliminación',
      message: '¿Estás seguro que deseas eliminar el resultado de laboratorio?',
      confirmAction: async () => {
        await removeSOCSample({ id: monitorSOCSampleId })
      },
    })
  }

  const findSOCSample = (socSampleId: string) => socSamples?.find(s => s.id === socSampleId) ?? null

  const openSOCSample = (socSampleId: string, mode: SOCSampleDialogMode) => {
    setSelectedSOCSample(findSOCSample(socSampleId))
    setDialogMode(mode)
    setCreateSOCSampleView(true)
  }

  const handleDownloadSOCSample = (socSampleId: string) => {
    const sample = findSOCSample(socSampleId)
    if (sample) downloadSOCSample(sample)
  }

  return (
    <>
      {currentFarm && (
        <Box>
          <Box sx={{ padding: '10px', textAlign: 'right' }}>
            <Button
              color="primary"
              component="label"
              disabled={isViewOnly}
              variant="contained"
              onClick={() => {
                setDialogMode('edit')
                setCreateSOCSampleView(true)
              }}
            >
              Crear resultado
            </Button>
          </Box>
          {createSOCSampleView && (
            <SOCSampleDialog
              farm={currentFarm}
              handleClose={() => {
                setSelectedSOCSample(null)
                setCreateSOCSampleView(false)
              }}
              initialMode={dialogMode}
              open={createSOCSampleView}
              readOnly={isViewOnly}
              socSample={selectedSOCSample}
            />
          )}
          {socSamples && (
            <SOCSamplesList
              handleDelete={handleDeleteSOCSample}
              handleDownload={handleDownloadSOCSample}
              handleEdit={socSampleId => openSOCSample(socSampleId, 'edit')}
              handleView={socSampleId => openSOCSample(socSampleId, 'view')}
              isDownloading={isDownloading}
              isViewOnly={isViewOnly}
              socSamples={socSamples}
            />
          )}
        </Box>
      )}
    </>
  )
}

export default SOCSample
